import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { ITextFieldProps, TextField } from '../../../../ui';

type IConfirmLicensePlateNumberProps = Partial<ITextFieldProps> & {
	defaultValue?: string;
};

export const ConfirmLicensePlateNumber = ({
	defaultValue,
	...props
}: IConfirmLicensePlateNumberProps) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<TextField
			type="text"
			defaultValue={defaultValue}
			label={t('user_form_confirm_license_plate_number_label')}
			placeholder={t('user_form_confirm_license_plate_number_placeholder')}
			invalid={!!errors.confirmLicensePlateNumber}
			error={errors.confirmLicensePlateNumber?.message as string}
			autoComplete="off"
			{...props}
			{...register('confirmLicensePlateNumber')}
		/>
	);
};
